module.exports = __webpack_public_path__ + "img/v3-comment.3bfb17e2.svg";